// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SegmentedControl_container__ZYIdi {
  display: flex;
  gap: calc(var(--gutter) / 8);
  background-color: var(--color-surface);
  border-radius: var(--radius-card);
  overflow: hidden;
  width: fit-content;
  padding: calc(var(--gutter) / 4);
}

.SegmentedControl_segment__Oscva {
  flex: 1 1;
  padding: calc(var(--gutter) / 2) var(--gutter);
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 500;
  color: var(--color-text-subtle);
  transition: all var(--animation-duration-default) linear;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: calc(var(--gutter) / 3);
  border-radius: var(--radius-default);
}
.SegmentedControl_segment__Oscva:hover:not(.SegmentedControl_active__LYxRa) {
  background-color: var(--color-surface-light);
  color: var(--color-text);
}
.SegmentedControl_segment__Oscva.SegmentedControl_active__LYxRa {
  background-color: var(--color-surface-interactive);
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/components/SegmentedControl/SegmentedControl.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4BAAA;EACA,sCAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,wDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,oCAAA;AACF;AACE;EACE,4CAAA;EACA,wBAAA;AACJ;AAEE;EACE,kDAAA;EACA,2BAAA;AAAJ","sourcesContent":[".container {\n  display: flex;\n  gap: calc(var(--gutter) / 8);\n  background-color: var(--color-surface);\n  border-radius: var(--radius-card);\n  overflow: hidden;\n  width: fit-content;\n  padding: calc(var(--gutter) / 4);\n}\n\n.segment {\n  flex: 1;\n  padding: calc(var(--gutter) / 2) var(--gutter);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  color: var(--color-text-subtle);\n  transition: all var(--animation-duration-default) linear;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: calc(var(--gutter) / 3);\n  border-radius: var(--radius-default);\n  \n  &:hover:not(.active) {\n    background-color: var(--color-surface-light);\n    color: var(--color-text);\n  }\n  \n  &.active {\n    background-color: var(--color-surface-interactive);\n    color: var(--color-primary);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SegmentedControl_container__ZYIdi`,
	"segment": `SegmentedControl_segment__Oscva`,
	"active": `SegmentedControl_active__LYxRa`
};
export default ___CSS_LOADER_EXPORT___;
